module.exports = __webpack_public_path__ + "static/media/img_Benchmarking104.72249f65.png";